import { render, staticRenderFns } from "./QuickSearch.vue?vue&type=template&id=0cc34772&scoped=true"
import script from "./QuickSearch.vue?vue&type=script&lang=js"
export * from "./QuickSearch.vue?vue&type=script&lang=js"
import style0 from "./QuickSearch.vue?vue&type=style&index=0&id=0cc34772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc34772",
  null
  
)

export default component.exports